import React from "react"
import { ProviderFinderParam, useStringSearchParam } from "../../utils/providerFinderSearchUrl"
import { FormattedMessage, useIntl } from "react-intl"
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Typography
} from "@carrotfertility/carotene-core"
import { MemberActions } from "#/services/memberActionTracking/memberActions"
import { useMemberActionTracking } from "#/services/memberActionTracking/useMemberActionTracking"
import { useJourney } from "#/components/carrot-plans/hooks/useJourney"

export function ProviderNetworksFilter({
  chipAndFilterText,
  externalProviderNetworkId
}: {
  chipAndFilterText: string
  externalProviderNetworkId: string
}): JSX.Element {
  const [isProviderNetworksSearchParam, setIsProviderNetworksSearchParam] = useStringSearchParam(
    ProviderFinderParam.ProviderNetworkId
  )
  const intl = useIntl()
  const { mutate: addMemberAction } = useMemberActionTracking()
  const { resolvedJourney } = useJourney()

  return externalProviderNetworkId ? (
    <Box
      display="flex"
      flexDirection="column"
      padding={(theme) => theme.spacing(theme.tokens.spacing.sm)}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.tokens.borderRadius.sm
      })}
    >
      <Box
        data-id="provider-networks-filter"
        display="flex"
        flexDirection="column"
        gap={(theme) => theme.spacing(theme.tokens.spacing.md)}
      >
        <FormControl>
          <FormControlLabel
            label={
              <Box
                component="span"
                display="flex"
                flexDirection="row"
                alignItems="center"
                gap={(theme) => theme.spacing(theme.tokens.spacing.xxl)}
              >
                <Typography fontWeight="bold" textTransform="uppercase" fontSize="0.75rem">
                  <FormattedMessage defaultMessage="{chipAndFilterText} only" values={{ chipAndFilterText }} />
                </Typography>
              </Box>
            }
            aria-label={intl.formatMessage(
              {
                defaultMessage: "Select providers within the {chipAndFilterText} network only"
              },
              { chipAndFilterText }
            )}
            control={
              <Checkbox
                name="isProviderNetworks"
                checked={!!isProviderNetworksSearchParam}
                onChange={(e) => {
                  const isChecked = e.target.checked
                  setIsProviderNetworksSearchParam(isChecked ? externalProviderNetworkId : null)
                  addMemberAction({
                    memberActionTaken: MemberActions.PROVIDER_FINDER_NETWORK_FILTER_TOGGLED,
                    metaData: {
                      filterEnabled: isChecked,
                      networkName: chipAndFilterText,
                      providerNetworkIdentifier: externalProviderNetworkId,
                      memberJourney: resolvedJourney
                    }
                  })
                }}
              />
            }
          />
          <FormHelperText sx={{ paddingInlineStart: (theme) => theme.spacing(theme.tokens.spacing.xxl) }}>
            <FormattedMessage defaultMessage="In-network providers are reviewed for quality and offer negotiated rates" />
          </FormHelperText>
        </FormControl>
      </Box>
    </Box>
  ) : null
}
